import React from 'react';
import NodeResolver from 'react-node-resolver';
import { TargetConsumer } from './spotlight-manager';
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */
const SpotlightTarget = ({
  children,
  name
}) => /*#__PURE__*/React.createElement(TargetConsumer, null, targetRef => targetRef ? /*#__PURE__*/React.createElement(NodeResolver, {
  innerRef: targetRef(name)
}, /*#__PURE__*/React.createElement(React.Fragment, null, children)) : children);
export default SpotlightTarget;